// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1qRQq","search":"Settings_search__3_Uab","filter":"Settings_filter__PWWQH"};